import React from 'react'
import "./Journal.css"
export default function Journal() {
  return (
    <div className='journal'>
        <div className="journalContainer">
            <div className="journalLeft">
                <h2>Lets Research</h2>
                <p>Over 20 years of experience CBR has acheived numerous achievments in field of science and technology</p>
            </div>
            <div className="journalRight">
                <h2>Get into a Field Now</h2>
                <p>Explore Beyond</p>
            </div>
        </div>
    </div>
  )
}
